// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".picture-table-component .distribute-btn[data-v-053c64eb]{color:#d94a7d!important}.picture-table-component .distributed-text[data-v-053c64eb]{font-weight:700;font-size:16px;color:#707070}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
